import { render, staticRenderFns } from "./EditSurveyFabButton.vue?vue&type=template&id=49628f88&scoped=true"
import script from "./EditSurveyFabButton.vue?vue&type=script&lang=js"
export * from "./EditSurveyFabButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49628f88",
  null
  
)

export default component.exports